import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/directives/index' // 全局注册自定义指令

//处理提示：Added non-passive event listener to a scroll-blocking <some> event.
import 'default-passive-events'

//element UI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

//弹窗组件
import layer from 'vue-layer'
import 'vue-layer/lib/vue-layer.css'
Vue.prototype.$layer = layer(Vue)

//打印
import Print from "vue-print-nb"
Vue.use(Print)

//全局样式
import '@/styles/index.scss'

//自定义全局组件
import '@/components/index.js'

//公共方法
import util from '@/utils/index.js'
Vue.prototype.$utils = util

//数据接口
import apis from '@/apis/index.js'
Vue.prototype.$apis = apis

//全局异常处理
Vue.config.errorHandler = function () { }

Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  render: (h) => h(App),
})
